<section id="services" class="services section-bg">
  <div class="container animated fadeIn">

    <div class="section-title" data-aos="fade-up">
      <h2>Servicios</h2>
      <p>Lote sobre calle <br> Hipólito Yrigoyen</p>
      <h3 class="pt-4">Don Emilio Construcciones <br> tiene el honor de presentar: <br> <strong>Loteo Don Emilio.</strong> </h3> <br>
      <h3 class="pb-4">Nuestro nuevo emprendimiento en <br> San Juan, Argentina.  <br> Nos distingue un trato <br> directo que posibilita menores costos y <br> mayores ganancias para el cliente.</h3>
    </div>

    <div class="row mb-5 pb-5">
      <div class="col-12 ml-auto mr-auto">
        <div class="embed-responsive embed-responsive-21by9">
          <iframe class="embed-responsive-item video" src="assets/img/lote.mp4" allowfullscreen></iframe>
        </div>
      </div>
    </div>

    <div class="row mb-5">
      <div class="col">
        <div class="card-columns ml-auto mr-auto">
          <div class="card">
            <img src="assets/img/lote1.jpg" class="card-img-top" alt="...">
          </div>
          <div class="card">
            <img src="assets/img/lote2.jpg" class="card-img-top" alt="...">
          </div>
          <div class="card">
            <img src="assets/img/lote3.jpg" class="card-img-top" alt="...">
          </div>
          <div class="card">
            <img src="assets/img/lote4.jpg" class="card-img-top" alt="...">
          </div>
          <div class="card">
            <img src="assets/img/lotesa.jpg" class="card-img-top">
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-10 col-sm-6 col-md-6 col-lg-3 d-flex justify-content-center align-items-stretch" data-aos="zoom-in" data-aos-delay="100">
        <div class="icon-box">
          <div class="icon"><i class="bx bx-home-alt"></i></div>
          <h4 class="title">Lotes</h4>
          <p class="description">Se ofrecen 12 lotes con fachada a vía de acceso principal a la ciudad, idóneos para hacer unidades comerciales con residencia.</p>
        </div>
      </div>

      <div class="col-xs-10 col-sm-6 col-md-6 col-lg-3 d-flex justify-content-center align-items-stretch" data-aos="zoom-in" data-aos-delay="200">
        <div class="icon-box">
          <div class="icon"><i class="bx bx-file"></i></div>
          <h4 class="title">Medidas</h4>
          <p class="description">Todas los lotes miden 26 m x 11 m menos la A10 que mide 22 m x 13 m.</p>
        </div>
      </div>

      <div class="col-xs-10 col-sm-6 col-md-6 col-lg-3 d-flex justify-content-center align-items-stretch" data-aos="zoom-in" data-aos-delay="300">
        <div class="icon-box">
          <div class="icon"><i class="bx bx-tachometer"></i></div>
          <h4 class="title">Escritura</h4>
          <p class="description">Ofrecemos un servicio de escrituración inmediata.</p>
        </div>
      </div>

      <div class="col-xs-10 col-sm-6 col-md-6 col-lg-3 d-flex justify-content-center align-items-stretch" data-aos="zoom-in" data-aos-delay="400">
        <div class="icon-box">
          <div class="icon"><i class="bx bx-water"></i></div>
          <h4 class="title">Servicios</h4>
          <p class="description">Cuentan con servicios de agua y electricidad.</p>
        </div>
      </div>

      <div class="col-12 justify-content-center d-flex align-items-stretch" data-aos="zoom-in" data-aos-delay="400">
        <div class="icon-box">
          <div class="icon"><i class="bx bx-dollar"></i></div>
          <h4 class="title">Precios</h4>
          <p class="description">Contamos con los mejores precios desde USD 10,000</p>
        </div>
      </div>

    </div>

    <div class="row">
      <div class="col-lg-9 d-flex align-items-stretch ml-auto mr-auto contact" data-aos="fade-up" data-aos-delay="100">
        <div class="info">
          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2858.600853104664!2d-68.57287075732499!3d-31.566198777303775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzHCsDMzJzU5LjYiUyA2OMKwMzQnMTguMyJX!5e0!3m2!1ses!2sar!4v1583025768807!5m2!1ses!2sar" frameborder="0" style="border:0; width: 100%; height: 290px;" allowfullscreen></iframe>
        </div>
      </div>
    </div>

</div>

</section><!-- End Services Section -->
